import { render, staticRenderFns } from "./UCProductGallery.vue?vue&type=template&id=5f9d151e&scoped=true&"
import script from "./UCProductGallery.vue?vue&type=script&lang=ts&"
export * from "./UCProductGallery.vue?vue&type=script&lang=ts&"
import style0 from "./UCProductGallery.vue?vue&type=style&index=0&id=5f9d151e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d151e",
  null
  
)

export default component.exports